import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import config from '../../../configs/config';
import { getLanguageSection, toggleSiteLanguage } from '../../../shared/services/languageService';
import Cookies from 'js-cookie';

const domain = window.location.origin;

function createInitialState() {
  return {
    homePage: Cookies.get('language') === "esp" ? domain + "/es/" : domain + "/",
    rewardsPage: Cookies.get('language') === "esp" ? domain + "/es/rewards_program.html" : domain + "/rewards_program.html",
    agentPage: "",
    agencyPage: "",
    loginPage: "",
    contactusPage: Cookies.get('language') === "esp" ? domain + "/es/contactus.html" : domain + "/contactus.html",
    privacyPage: Cookies.get('language') === "esp" ? domain + "/es/privacy_es.html" : domain + "/privacy.html"
  };
}

function getCurrentYear() {
  return new Date().getFullYear();
}

function FooterPublic() {
  const [pages, setPages] = useState(createInitialState);

  const language = getLanguageSection('footerpublic');
  const currentYear = getCurrentYear();

  useEffect(() => {
    if (Cookies.get('iscanada') === -1) {
      setPages({
        homePage: Cookies.get('language') === "esp" ? domain + "/es/" : domain + "/",
        rewardsPage: Cookies.get('language') === "esp" ? domain + "/es/rewards_program.html" : domain + "/rewards_program.html",
        agentPage: "?iscanada=-1",
        agencyPage: "?iscanada=-1",
        contactusPage: Cookies.get('language') === "esp" ? domain + "/es/contactus.html" : domain + "/contactus.html",
        loginPage: "?iscanada=-1",
        privacyPage: Cookies.get('language') === "esp" ? domain + "/es/privacy.html" : domain + "/privacy.html"
      });
    }
  }, []);

  const selectlanguage = (event) => {
    event.preventDefault();
    toggleSiteLanguage();
  };

  return (
     <div className="mr-ui mt-10">
     <div className="hidden lg:block">
     <div className="h-1 bg-[#f5660b]">

      </div>
     </div>
     <div className="hidden lg:block">
     <div className="bg-[#23a9d6] py-8 text-white">
     <div className="mx-auto w-full max-w-7xl px-8">
      <div className="grid grid-cols-3 items-center gap-8">
            <div>
            <p className="m-0 mb-4 text-sm font-semibold uppercase tracking-wide">{language.connect}</p>
            <div>


                                <div className="flex items-center gap-5">

                                <div>
                                <a target="_blank" rel="noreferrer" href="https://www.facebook.com/MarivalResortsOficial/"><img src={config.publicurl+"img/fbicon.png"} className="h-7 w-7" alt="" /></a>
                                </div>

                                <div>
                                <a target="_blank" rel="noreferrer" href="https://www.instagram.com/marivalresorts/"><img src={config.publicurl+"img/insticon.png"} className="h-7 w-7" alt="" /></a>
                               </div>

                                <div>
                                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/marival-group/"><img src={config.publicurl+"img/linkedinicon.png"} className="h-7 w-7" alt="" /></a>
                               </div>
                               <div>
                               <p className="m-0 text-[#4BB1D0]"></p>
                               </div>
                               </div>

            </div>
            </div>
            <div className="text-center">
                <p className="m-0 text-sm font-semibold uppercase tracking-wide">{language.news}</p>
                <div>
                <div>
                <div className="mx-auto max-w-xs">
                </div>
                </div>
                </div>
            </div>
            <div>
                <div className="mt-0 flex justify-end">
                  <img src={config.publicurl+"img/Marivalblanco_.png"} className="h-12 w-auto" alt=""/>
                </div>
            </div>
      </div>
     </div>
     </div>

     </div>
     <div className="hidden lg:block">
     <div className="bg-white py-5 text-slate-700 shadow-sm">
     <div>
          <div>

              <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-2 px-8 text-sm font-medium">
              <h4 className="m-0 text-sm font-medium text-slate-500">Marival® Rewards Copyright {currentYear} - All Rights Reserved</h4><a href={pages.privacyPage} className="text-slate-700 transition-colors hover:text-[#198fd0]"><p className="m-0">Privacy Notice</p></a>
                      <a className="text-slate-700 transition-colors hover:text-[#198fd0]"  href="/" onClick={selectlanguage} ><p className="m-0">{language.lang}</p></a>
                      <NavLink className="text-slate-700 transition-colors hover:text-[#198fd0]"  to={"/login"+pages.loginPage}><p className="m-0">{language.login}</p></NavLink>
                      <a className="text-slate-700 transition-colors hover:text-[#198fd0]"  href={pages.contactusPage}><p className="m-0">{language.contact}</p></a>

                      <NavLink className="text-slate-700 transition-colors hover:text-[#198fd0]"  to={"/agentregister"+pages.agentPage}><p className="m-0">{language.registeragent}</p></NavLink>
                      <NavLink className="text-slate-700 transition-colors hover:text-[#198fd0]"  to={"/agencyregister"+pages.agencyPage}><p className="m-0">{language.registeragency}</p></NavLink>

                      <a className="text-slate-700 transition-colors hover:text-[#198fd0]"  href={pages.rewardsPage}><p className="m-0">{language.rewards}</p></a>
                      <a className="text-[#198fd0] transition-colors hover:text-[#0d6ea9]"  href={pages.homePage}><p className="m-0">{language.welcome}</p></a>
              </div>

          </div>

      </div>
     </div>
     </div>
     {/***************mobile***************/}
     <div className="lg:hidden">
          <div className="h-1 bg-[#f5660b]">

          </div>
          <div className="bg-[#23a9d6] text-center text-white">

              <div className="px-5 py-8">
                  <p className="m-0 mb-4 text-sm font-semibold uppercase tracking-wide">CONNECT</p>
                  <div className="mb-5 flex items-center justify-center gap-5">
                      <a target="_blank" rel="noreferrer" href="https://www.facebook.com/MarivalResortsOficial/"><img src={config.publicurl+"img/fbicon.png"} className="h-7 w-7" alt="" /></a>
                      <a target="_blank" rel="noreferrer" href="https://www.instagram.com/marivalresorts/"><img src={config.publicurl+"img/insticon.png"} className="h-7 w-7" alt="" /></a>
                      <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/marival-group/"><img src={config.publicurl+"img/linkedinicon.png"} className="h-7 w-7" alt="" /></a>
                  </div>
                  <div className="mb-6 flex items-center justify-center gap-2">
                      <input placeholder="@email" type="text" className="h-9 w-40 rounded-md border border-white/70 bg-white px-3 text-sm text-slate-700 shadow-none" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
                      <button className="h-9 rounded-md border-0 bg-[#f5660b] px-4 text-sm font-semibold text-white">GO</button>
                  </div>
                  <img src={config.publicurl+"img/Marivalblanco_.png"} className="mx-auto h-12 w-auto" alt=""/>

              </div>

          </div>
          <div className="bg-white px-5 py-6 text-center text-slate-700 shadow-sm">
              <div>
                  <h4 className="m-0 mb-4 text-sm font-medium text-slate-500">Marival® Rewards Copyright {currentYear} - All Rights Reserved</h4>
                  <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium">
                      <a className="text-slate-700 transition-colors hover:text-[#198fd0]"  href="/" onClick={selectlanguage} ><p className="m-0">{language.lang}</p></a>
                      <NavLink className="text-slate-700 transition-colors hover:text-[#198fd0]"  to={"/login"+pages.loginPage}><p className="m-0">{language.login}</p></NavLink>
                      <a className="text-slate-700 transition-colors hover:text-[#198fd0]"  href={pages.contactusPage}><p className="m-0">{language.contact}</p></a>

                      <NavLink className="text-slate-700 transition-colors hover:text-[#198fd0]"  to={"/agentregister"+pages.agentPage}><p className="m-0">{language.registeragent}</p></NavLink>
                      <NavLink className="text-slate-700 transition-colors hover:text-[#198fd0]"  to={"/agencyregister"+pages.agencyPage}><p className="m-0">{language.registeragency}</p></NavLink>

                      <a className="text-slate-700 transition-colors hover:text-[#198fd0]"  href={pages.rewardsPage}><p className="m-0">{language.rewards}</p></a>
                      <a className="text-[#198fd0] transition-colors hover:text-[#0d6ea9]"  href={pages.homePage}><p className="m-0">{language.welcome}</p></a>
                  </div>
              </div>
          </div>
     </div>
     </div>
  );
}

export default FooterPublic;
